import React from 'react';
import { Box } from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router';
import { useAppDispatch } from 'store/store';
import { createDrawingBase } from 'store/actions/drawingBaseActions';
import { CustomTextField } from 'components/FormFields/CustomTextField/CustomTextField';
import { CustomSelect } from 'components/FormFields/CustomSelect/CustomSelect';
import RedButton from 'Styled/RedButton';
import TextButton from 'Styled/TextButton';
import { isFulfilled } from '@reduxjs/toolkit';
import { DrawingTypeId, DrawingTypeLabel } from 'types/enums/DrawingType';
import { PageHeader } from 'components/Layout/PageHeader';
import { preventEnterSubmit } from 'utility/preventEnterSubmit';

const validationSchema = Yup.object({
  name: Yup.string().required('Name ist erforderlich'),
  drawingTypeId: Yup.number().required('Ziehungstyp ist erforderlich'),
});

const drawingTypeOptions = Object.entries(DrawingTypeLabel).map(([id, title]) => ({ id, title }));

export const DrawingBaseCreatePage: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { lotteryId } = useParams<{ lotteryId: string }>();

  return (
    <Box>
      <PageHeader title="Neue Ziehungsbasis" />

      <Formik
        initialValues={{ name: '', drawingTypeId: '' as string | DrawingTypeId }}
        validationSchema={validationSchema}
        onSubmit={async (values) => {
          const result = await dispatch(
            createDrawingBase({
              name: values.name,
              lotteryId: Number(lotteryId),
              drawingTypeId: Number(values.drawingTypeId),
            })
          );
          if (isFulfilled(result)) {
            navigate(`/lottery/${lotteryId}/drawing-bases/${result.payload.id}/edit`);
          }
        }}
      >
        {({ values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting }) => (
          <Form onKeyDown={preventEnterSubmit}>
            <Box sx={{ maxWidth: 600, display: 'flex', flexDirection: 'column', gap: 2 }}>
              <CustomTextField name="name" label="Name" value={values.name} onChange={handleChange} onBlur={handleBlur} error={touched.name && Boolean(errors.name)} helperText={touched.name ? errors.name : ''} />

              <CustomSelect name="drawingTypeId" label="Ziehungstyp" options={drawingTypeOptions} value={values.drawingTypeId} onChange={(val) => setFieldValue('drawingTypeId', val)} error={touched.drawingTypeId && Boolean(errors.drawingTypeId)} helperText={touched.drawingTypeId ? (errors.drawingTypeId as string) : ''} />

              <Box sx={{ display: 'flex', gap: 2, marginTop: 2 }}>
                <RedButton type="submit" disabled={isSubmitting}>
                  Erstellen
                </RedButton>
                <TextButton onClick={() => navigate(`/lottery/${lotteryId}/drawing-bases`)}>Abbrechen</TextButton>
              </Box>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
};
